export class TimeSheetExportHistoryDto {
  public dateModified: string;
  public modifiedBy: string;
  public exportFlag: number;
  public exportMessage: string;
  public totalCost: number;
}
